<template>
	<li class="drag-drop__list-item">
		<div class="draggable-item">
			<div class="draggable-item__body">
				<span
					:class="[
						'draggable-item__icon',
						isGrabbing && 'is-grabbing'
					]"
					@mousedown="isGrabbing = true"
					@mouseup="isGrabbing = false"
					@mouseleave="isGrabbing = false"
				>
					<i class="icon icon-grab" />
				</span>
				<section class="form-field-prompt">
					<div class="form-field-prompt__content-primary">
						<span class="form-field-prompt__content-primary-field">
							<Input
								className="field__input"
								label="Field Name"
								:name="`FieldName_${value[mapping.id]}`"
								:required="true"
								:value="value[mapping.name]"
								:forceCustomErrorMessage="value.errorMsg"
								@input="updateValue"
								@hasError="handlerError"
								v-if="editMode"
							/>
							<p
								class="form-field-prompt__content-field-text"
								v-else
							>
								<span
									class="form-field-prompt__content-field-text-emphasized"
								>
									{{ value[mapping.name] }}
								</span>
							</p>
						</span>
						<span class="form-field-prompt__content-primary-prompt">
							<Dropdown
								:displayHelp="false"
								:showClearSelectedButton="false"
								label="Prompt Order"
								:options="inputFieldsNames"
								:value="value[mapping.order]"
								@change="updatePromptOrder"
							/>
						</span>
					</div>
					<div
						class="form-field-prompt__content-secondary"
						v-if="editMode"
					>
						<p class="form-field-prompt__content-field-text">
							<span
								class="form-field-prompt__content-field-text-emphasized"
							>
								SQL ID:
							</span>

							<span
								class="form-field-prompt__content-field-text-id"
							>
								{{ value[mapping.id] }}
							</span>
						</p>

						<Button
							:btnClick="copySqlId"
							:className="
								'btn--icon-only form-field-prompt__content-secondary-copy'
							"
							:iconBeforeLabel="false"
							:iconClassName="'icon-copy'"
						/>
						<Button
							:btnClick="deleteHandler"
							:className="
								'btn--icon-only form-field-prompt__content-secondary-delete'
							"
							:iconBeforeLabel="false"
							:iconClassName="'icon-delete-glenn'"
						/>
					</div>
				</section>
			</div>
		</div>
	</li>
</template>

<script>
import Button from '@/components/forms/button/button';
import Input from '@/components/forms/input/input';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import { keys } from '@/utils/object.js';
import { isObject } from '@/utils/inspect';
import { copyToClipboard } from '@/utils/function';
export default {
	name: 'FieldPromptItem',
	components: {
		Button,
		Input,
		Dropdown
	},
	props: {
		value: {
			type: Object,
			required: true
		},
		inputFieldsNames: {
			type: Array,
			default: () => []
		},
		editMode: {
			type: Boolean,
			required: true
		},
		mapping: {
			type: Object,
			default: () => {
				return {
					name: 'keyboardPrompt',
					order: 'order',
					id: 'id'
				};
			}
		}
	},
	data() {
		return {
			promptOrderItems: [],
			formErrors: [],
			isGrabbing: false
		};
	},
	computed: {
		hasPositiveSqlId() {
			return this.value[this.mapping.id] > 0;
		}
	},
	methods: {
		copySqlId() {
			copyToClipboard(this.value[this.mapping.id]);
		},
		deleteHandler() {
			this.$emit('delete', this.value[this.mapping.id]);
		},
		updateValue(val) {
			let objValue = { ...this.value };
			objValue[this.mapping.name] = val;
			this.$emit('input', objValue);
		},
		updatePromptOrder(val) {
			let objValue = { ...this.value };
			let oldPromptOrder = objValue.order;
			Object.assign(objValue, {
				oldPromptOrder: oldPromptOrder,
				[this.mapping.order]: val
			});
			// objValue.oldPromptOrder = objValue.order;
			// objValue.order = val;
			this.$emit('changePromptOrder', objValue);
		},
		handlerError(obj) {
			if (isObject(obj)) {
				var key = keys(obj)[0];
				const idx = this.formErrors.findIndex(x => keys(x)[0] == key);

				if (idx > -1) {
					if (!obj[key]) {
						this.formErrors.splice(idx, 1);
					}
				} else {
					if (obj[key]) {
						this.formErrors.push(obj);
					}
				}
			}
			this.$emit('hasErrors', {
				hasError: this.formErrors.length > 0,
				...this.value
			});
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Drag and Drop - Laser Form Field Prompt
    * Can use SCSS variables = TRUE
*/

.form-field-prompt {
	width: 100%;
	align-items: center;

	@include mq($from: md) {
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__content-field-text {
		display: inline-flex;
		height: 100%;
		align-items: center;
		font-size: $default-font-size - 1;

		&-emphasized {
			overflow: hidden;
			font-weight: $medium-font-weight;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}

		&-id {
			margin-left: $gutter-md;
		}
	}

	&__content-primary {
		@include mq($from: sm-l) {
			display: inline-flex;
			gap: $gutter-xl;
		}

		&-prompt {
			display: flex;
			margin: $gutter-xl 0;
			@include mq($from: sm-l) {
				margin: 0;
			}
			@include mq($from: md) {
				margin-right: $gutter-xxl;
			}
		}

		&-field {
			@include mq($from: md) {
				width: 280px;
				margin: 0;
			}
		}
	}

	&__content-secondary {
		display: flex;
		align-items: center;
		margin-top: $gutter-xl;

		@include mq($from: md-l) {
			margin-top: 0;
		}

		&-copy {
			margin-left: $gutter-lg;
		}

		&-delete {
			margin-left: auto;

			@include mq($from: sm-l) {
				margin-left: $gutter-xxl;
			}
		}
	}
}

::v-deep .btn--icon-only {
	font-size: $icon-font-size - 6;
	min-width: max-content;
}

// Drag Drop styles - DO NOT REUSE; use draggable-list component control if you need drag drop behavior
.draggable-item {
	border: $form-input-border;
	background: $white;
	border-radius: $form-border-radius;
	position: relative;

	&__body {
		display: grid;
		grid-template-columns: auto 1fr;
		width: 100%;
		padding: $padding-md;
	}

	&__icon {
		display: inline-flex;
		align-items: center;
		min-width: 32px;
		margin-right: $gutter-sm;
		font-size: 15px;
		color: var(--draggable-icon-color);
		cursor: grab;

		&.is-grabbing {
			cursor: grabbing;
		}
	}

	&.is-editing {
		grid-template-columns: auto;

		.draggable-item__icon {
			display: none;
		}
	}
}

.is-ghost {
	.draggable-item {
		&:before {
			content: '';
			background: $neutral-4;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			display: block;
			z-index: 20;
			border-radius: $border-radius;
			opacity: 0.8;
		}
	}
}

.is-sortable-chosen {
	.draggable-item {
		border: 2px solid $base;
		background-color: white;
		opacity: 1;
	}
}
</style>
